import { AppScreenNames, SecurityLoggingType } from "../../Enums/ChoiceEnums";
import { IStatusResponse, StringOrNothing, putVoid } from "../ChoiceApi";

// Add an audit log entry.  Commonly used to log View actions for a screen
export async function addSimpleScreenLogEntry(screenName: AppScreenNames, logEntryType: SecurityLoggingType, statementID: string): Promise<StringOrNothing>
{
    return putVoid(`api/ChoiceAudit/Log`, {securityScreen: screenName, logEntryType, statementID});
}

export async function addScreenViewLogEntry(screenName: AppScreenNames, statementID: string): Promise<StringOrNothing>
{
    return addSimpleScreenLogEntry(screenName, SecurityLoggingType.View, statementID);
}